import React from "react";
import { View, Text, Button } from "ui";
import { styled } from "styles";
import PlusCircleIcon from "mdi-react/PlusCircleIcon";
import { MemoPhoto, Memo } from "types";
import _ from "lodash";
import { photoMutations } from "api";

interface P {
  photos: MemoPhoto[];
  memo: Memo;
  onClick?: (photo: MemoPhoto) => void;
}
export default class AddPicture extends React.Component<P> {
  public state = {
    selectedPhotoId: undefined,
    photoLink: undefined
  };

  public getBase64 = file => {
    return new Promise<string>((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result instanceof ArrayBuffer) {
          resolve("");
        } else {
          resolve(reader.result);
        }
      };
      reader.onerror = error => {
        reject(error);
      };
    });
  }

  public render = () => {
    const { photos, memo } = this.props;

    return (
      <AddPicView
        bg="transparent"
        flexDirection="column"
        justifyContent="space-between"
        px="5px"
      >
        <photoMutations.UpsertPhoto>
          {upsertPhoto => (
            <React.Fragment key={`${photos.length}`}>
              <input
                accept="image/*"
                style={{ display: "none" }}
                id={`file-upload`}
                type="file"
                onChange={async event => {
                  let picture = event.target.files[0];
                  if (!picture) {
                    return;
                  }

                  let photo = await this.getBase64(picture);
                  await upsertPhoto({
                    variables: {
                      memo_id: memo.id,
                      photo
                    }
                  });
                }}
              />
              <label htmlFor={`file-upload`}>
                <View flexDirection="row" justifyContent="center">
                  <AddView
                    bg="grey"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <PlusCircleIcon color="white" size={40} />
                  </AddView>
                </View>
              </label>
            </React.Fragment>
          )}
        </photoMutations.UpsertPhoto>
      </AddPicView>
    );
  }
}
const AddPicView = styled(View)``;
const AddView = styled(View)`
  height: 6rem;
  width: 6rem;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/AddPicture.tsx